//@flow
import {
  HISTORY_PAYMENTS,
  HISTORY_PAYMENTS_PROCESSED,
  HISTORY_PAYMENTS_COMPLETED,
  PROMISE_PENDING,
  PROMISE_REJECTED,
  PROMISE_FULFILLED,
  ASCENDING,
  DESCENDING,
  INC_DATA_PEMBELIAN,
  INC_DATA_PEMBELIAN_PROCESSED,
  AUTH_SIGN_OUT,
  ACTION_SELLER_SELL,
  AWB_SENT_KA,
  BUY_COMPLETIONS,
  LIST_SELLING,
  LIST_SELLING_PENDING,
  LIST_SELLING_HISTORY,
  SUSPEND_SELL_REQUEST,
  UPDATE_LISTING_EXPIRY,
  SORT_FILTER_SELLING_SELLER,
  SORT_FILTER_PROCESS_SELLER,
  SORT_FILTER_HISTORY_SELLER,
  // UPDATE_BULK_RENEW
  HOLIDAY_MODE_REQUEST,
  SELLER_INPUT_AWB,
  FETCH_SHIPPING_TRACKING
} from '../constants'
import onError from "../utils/error";
import { UPDATE_BULK_RENEW } from '../constants/saleConstants';

/*
type Actions = {
  type: string,
  payload: {
    message: string,
    status_code: number,
    data: Object,
    ascDesc: Object
  }
}
type _SellsList = (state:Object, data:Object, message:?string, status_code:?number, tabs:?string)=>{}
*/

const initialState = {
  pembelian: {
    isFetch: false,
    current_page: null,
    dataPembelian: [],
    last_page: null,
    total: null,
    per_page: null,
    total_transaction: null,
    success_transaction: null,
    error: null
  },
  pembelianProcessed: {
    isFetch: false,
    current_page: null,
    dataPembelian: [],
    last_page: null,
    total: null,
    per_page: null,
    total_transaction: null,
    success_transaction: null,
    error: null
  },
  pembelianCompleted: {
    isFetch: false,
    current_page: null,
    dataPembelian: [],
    last_page: null,
    total: null,
    per_page: null,
    total_transaction: null,
    success_transaction: null,
    error: null
  },
  penjualan: {
    isFetch: false,
    isSubmit: false,
    dataPenjualan: [],
    current_page: null,
    last_page: null,
    total_penjualan: null,
    success_transaction: null,
    error: null
  },
  pending: {
    isFetch: false,
    dataPenjualan: [],
    current_page: null,
    last_page: null,
    total_penjualan: null,
    success_transaction: null,
    error: null,
    order_masuk: {
      isFetch: false,
      error: null
    }
  },
  history: {
    isFetch: false,
    dataPenjualan: [],
    current_page: null,
    last_page: null,
    total_penjualan: null,
    success_transaction: null,
    error: null
  },
  buyCompletions: {
    isFetch: false,
    message: null,
    status_code: null
  },
  holidayMode: {
    isSubmit: false,
    data: null,
    message: null,
    status_code: null
  },
  awb: {
    isSubmit: false,
    data: null,
    message: null,
    status_code: null
  },
  bulkExpiry: {
    isSubmit: false,
    data: null,
    message: null,
    status_code: null
  },
  shippingTrackingData: {
    isFetch: false,
    data: null,
    message: null,
    status_code: null
  }
}

const historyPayments = (state, { data: { data, current_page, last_page, per_page, total, total_transaction, success_transaction } }) => {
  let newState = {
    ...state,
    pembelian: {
      ...state.pembelian,
      isFetch: false,
      dataPembelian: [...data],
      current_page,
      last_page,
      per_page,
      total,
      total_transaction,
      success_transaction,
    }
  }

  return newState
}

const historyPaymentsProcessed = (state, { data: { data, current_page, last_page, per_page, total, total_transaction, success_transaction } }) => {
  let newState = {
    ...state,
    pembelianProcessed: {
      ...state.pembelianProcessed,
      isFetch: false,
      dataPembelian: [...data],
      current_page,
      last_page,
      per_page,
      total,
      total_transaction,
      success_transaction,
    }
  }

  return newState
}

const historyPaymentsCompleted = (state, { data: { data, current_page, last_page, per_page, total, total_transaction, success_transaction } }) => {
  let newState = {
    ...state,
    pembelianCompleted: {
      ...state.pembelianCompleted,
      isFetch: false,
      dataPembelian: (!current_page || current_page === 1) ? data : [...data],
      current_page,
      last_page,
      per_page,
      total,
      total_transaction,
      success_transaction,
    }
  }

  return newState
}

const _ascending = (state, target) => {
  let newData
  if (target === 'transaction') {
    let _data = [...state.pembelian.dataPembelian].sort((dataA, dataB) => {
      return new Date(dataA.created_at) - new Date(dataB.created_at)
    })
    newData = { ...state, pembelian: { ...state.pembelian, dataPembelian: _data } }
    return newData
  }

  return state
}

const _descending = (state, target) => {
  let newData
  if (target === 'transaction') {
    let _data = [...state.pembelian.dataPembelian].sort((dataA, dataB) => {
      return new Date(dataB.created_at) - new Date(dataA.created_at)
    })
    newData = { ...state, pembelian: { ...state.pembelian, dataPembelian: _data } }
    return newData
  }

  return state
}

const _incHistoryPayment = (state, { data: { current_page, data, last_page }, ascDesc }) => {
  window.scrollTo(0, 0)
  let newState
  let sortData = {
    ...state,
    pembelian: {
      ...state.pembelian,
      isFetch: false,
      current_page,
      last_page,
      // dataPembelian: [...state.pembelian.dataPembelian, ...data]
      dataPembelian: data
    }
  }

  if (ascDesc) {
    newState = _ascending(sortData, 'transaction')
  } else {
    newState = _descending(sortData, 'transaction')
  }

  return newState
}
const _incHistoryPaymentProcessed = (state, { data: { current_page, data, last_page }, ascDesc }) => {
  window.scrollTo(0, 0)
  let newState
  let sortData = {
    ...state,
    pembelianProcessed: {
      ...state.pembelianProcessed,
      isFetch: false,
      current_page,
      last_page,
      // dataPembelian: [...state.pembelian.dataPembelian, ...data]
      dataPembelian: data
    }
  }

  if (ascDesc) {
    newState = _ascending(sortData, 'transaction')
  } else {
    newState = _descending(sortData, 'transaction')
  }

  return newState
}

const _sellsList = (state, { data: { current_page, data, last_page, total_transaction, success_transaction, total, per_page }, message, status_code }) => {
  // console.log('reset', reset);
  let newState = {
    ...state,
    penjualan: {
      ...state.penjualan,
      isFetch: false,
      dataPenjualan: data,
      total_penjualan: total_transaction,
      current_page,
      last_page,
      total,
      per_page,
      success_transaction,
      message,
      status_code,
      error: null,
    }
  }

  return newState
}

const _sellsProcess = (state, { data: { current_page, data, last_page, total_transaction, success_transaction, total, per_page }, message, status_code }) => {
  let newState = {
    ...state,
    pending: {
      ...state.pending,
      isFetch: false,
      dataPenjualan: data,
      total_penjualan: total_transaction,
      current_page,
      last_page,
      total,
      per_page,
      success_transaction,
      message,
      status_code,
      error: null,
    }
  }

  return newState
}

const _sellsHistory = (state, { data: { current_page, data, last_page, total_transaction, success_transaction, total, per_page }, message, status_code }) => {
  let newState = {
    ...state,
    history: {
      ...state.history,
      isFetch: false,
      dataPenjualan: data,
      total_penjualan: total_transaction,
      current_page,
      last_page,
      total,
      per_page,
      success_transaction,
      message,
      status_code,
      error: null,
    }
  }

  return newState
}

const _ChangePriceAndStatus = (state, { payload }) => {
  const { data, status_code, message } = payload;
  let newDataPenjualan = {
    ...state.penjualan,
    isSubmit: false,
    error: null,
    message: message,
    status_code: status_code,
    dataPenjualan: [...state.penjualan.dataPenjualan].map((item, index) => {
      let oldData = { ...item }

      if (item.id === data.id) {
        oldData.asking_price = data.asking_price
        oldData.status = data.status
        oldData.expiry = data.expiry
        oldData.day_lefts = data.day_lefts
      }

      return oldData
    })
  }
  let newState = {
    ...state,
    penjualan: newDataPenjualan,
  }

  return newState
}

const historyReducer = (state = initialState, actions) => {
  // console.log("Action.payloads: ", actions )

  switch (actions.type) {
    case `${HISTORY_PAYMENTS}${PROMISE_PENDING}`:
      return ({
        ...state, "pembelian": { ...state.pembelian, isFetch: true }
      });
    case `${HISTORY_PAYMENTS}${PROMISE_FULFILLED}`:
      return (historyPayments(state, actions.payload));
    case `${HISTORY_PAYMENTS}${PROMISE_REJECTED}`:
      return ({
        ...state,
        pembelian: {
          ...state.pembelian,
          isFetch: false,
          error: actions.payload.response ? {
            ...actions.payload.response.data.error
          } : {}
        }
      });

    case `${HISTORY_PAYMENTS_PROCESSED}${PROMISE_PENDING}`:
      return ({
        ...state, "pembelianProcessed": { ...state.pembelianProcessed, isFetch: true }
      });
    case `${HISTORY_PAYMENTS_PROCESSED}${PROMISE_FULFILLED}`:
      return (historyPaymentsProcessed(state, actions.payload));
    case `${HISTORY_PAYMENTS_PROCESSED}${PROMISE_REJECTED}`:
      return ({
        ...state, pembelianProcessed: { ...state.pembelianProcessed, isFetch: false, error: { ...actions.payload.response.data.error } }
      });

    case `${HISTORY_PAYMENTS_COMPLETED}${PROMISE_PENDING}`:
      return { ...state, historyPaymentsCompleted: { ...state.historyPaymentsCompleted, isFetch: true } }
    case `${HISTORY_PAYMENTS_COMPLETED}${PROMISE_FULFILLED}`:
      return (historyPaymentsCompleted(state, actions.payload))
    case `${HISTORY_PAYMENTS_COMPLETED}${PROMISE_REJECTED}`: {
      return { ...state, historyPaymentsCompleted: { ...state.historyPaymentsCompleted, isFetch: false, error: { ...actions.payload.response.data.error } } }
    }

    case ASCENDING: return (_ascending(state, actions.payload))
    case DESCENDING: return _descending(state, actions.payload)

    case `${INC_DATA_PEMBELIAN}${PROMISE_PENDING}`:
      return ({
        ...state, pembelian: { ...state.pembelian, isFetch: true }
      })
    case `${INC_DATA_PEMBELIAN}${PROMISE_FULFILLED}`: return _incHistoryPayment(state, actions.payload)
    case `${INC_DATA_PEMBELIAN}${PROMISE_REJECTED}`:
      return ({
        ...state, pembelian: { ...state.pembelian, isFetch: "error" }
      })

    case `${INC_DATA_PEMBELIAN_PROCESSED}${PROMISE_PENDING}`:
      return ({
        ...state, pembelianProcessed: { ...state.pembelianProcessed, isFetch: true }
      })
    case `${INC_DATA_PEMBELIAN_PROCESSED}${PROMISE_FULFILLED}`: return _incHistoryPaymentProcessed(state, actions.payload)
    case `${INC_DATA_PEMBELIAN_PROCESSED}${PROMISE_REJECTED}`:
      return ({
        ...state, pembelianProcessed: { ...state.pembelianProcessed, isFetch: "error" }
      })

    case `${LIST_SELLING}${PROMISE_PENDING}`:
      return ({
        ...state, "penjualan": { ...state.penjualan, isFetch: true }
      });
    case `${LIST_SELLING}${PROMISE_FULFILLED}`:
      return _sellsList(state, actions.payload);
    case `${LIST_SELLING}${PROMISE_REJECTED}`:
      return ({
        ...state, "penjualan": { ...state.penjualan, isFetch: false, error: { ...actions.payload } }
      });

    //sort list selling
    case `${SORT_FILTER_SELLING_SELLER}${PROMISE_PENDING}`:
      return ({
        ...state, "penjualan": { ...state.penjualan, isFetch: true }
      });
    case `${SORT_FILTER_SELLING_SELLER}${PROMISE_FULFILLED}`:
      return _sellsList(state, actions.payload);
    case `${SORT_FILTER_SELLING_SELLER}${PROMISE_REJECTED}`:
      return ({
        ...state, "penjualan": { ...state.penjualan, isFetch: false, error: { ...actions.payload } }
      });

    case `${LIST_SELLING_PENDING}${PROMISE_PENDING}`:
      return ({
        ...state, "pending": { ...state.pending, isFetch: true }
      });
    case `${LIST_SELLING_PENDING}${PROMISE_FULFILLED}`:
      return _sellsProcess(state, actions.payload);
    case `${LIST_SELLING_PENDING}${PROMISE_REJECTED}`:
      return ({
        ...state, "pending": { ...state.pending, isFetch: false, error: { ...actions.payload } }
      });

    //sort list process
    case `${SORT_FILTER_PROCESS_SELLER}${PROMISE_PENDING}`:
      return ({
        ...state, "pending": { ...state.pending, isFetch: true }
      });
    case `${SORT_FILTER_PROCESS_SELLER}${PROMISE_FULFILLED}`:
      return _sellsProcess(state, actions.payload);
    case `${SORT_FILTER_PROCESS_SELLER}${PROMISE_REJECTED}`:
      return ({
        ...state, "pending": { ...state.pending, isFetch: false, error: { ...actions.payload } }
      });

    case `${LIST_SELLING_HISTORY}${PROMISE_PENDING}`:
      return ({
        ...state, "history": { ...state.history, isFetch: true }
      });
    case `${LIST_SELLING_HISTORY}${PROMISE_FULFILLED}`:
      return _sellsHistory(state, actions.payload);
    case `${LIST_SELLING_HISTORY}${PROMISE_REJECTED}`:
      return ({
        ...state, "history": { ...state.history, isFetch: false, error: { ...actions.payload } }
      });

    //sort list history
    case `${SORT_FILTER_HISTORY_SELLER}${PROMISE_PENDING}`:
      return ({
        ...state, "history": { ...state.history, isFetch: true }
      });
    case `${SORT_FILTER_HISTORY_SELLER}${PROMISE_FULFILLED}`:
      return _sellsHistory(state, actions.payload);
    case `${SORT_FILTER_HISTORY_SELLER}${PROMISE_REJECTED}`:
      return ({
        ...state, "history": { ...state.history, isFetch: false, error: { ...actions.payload } }
      });

    case `${ACTION_SELLER_SELL}${PROMISE_PENDING}`:
      return ({
        ...state, "pending": { ...state.pending, "order_masuk": { ...state.pending.order_masuk, isFetch: true } }
      })
    case `${ACTION_SELLER_SELL}${PROMISE_FULFILLED}`:
      return ({
        ...state, "pending": { ...state.pending, "order_masuk": { isFetch: false, status_code: actions.payload.status_code, error: null } }
      })
    case `${ACTION_SELLER_SELL}${PROMISE_REJECTED}`:
      return ({
        ...state, "pending": { ...state.pending, "order_masuk": { isFetch: false, error: { ...actions.payload } } }
      })
    case `${BUY_COMPLETIONS}${PROMISE_PENDING}`: return ({
      ...state, "buyCompletions": { ...initialState.buyCompletions, isFetch: true }
    })
    case `${BUY_COMPLETIONS}${PROMISE_FULFILLED}`: return ({
      ...state, "buyCompletions": { isFetch: false, message: actions.payload.message, status_code: actions.payload.status_code }
    })
    case `${BUY_COMPLETIONS}${PROMISE_REJECTED}`: return ({
      ...state, "buyCompletions": { isFetch: false, message: actions.payload.response.data.error.message, status_code: actions.payload.response.data.error.status_code }
    })
    case `${UPDATE_LISTING_EXPIRY}${PROMISE_PENDING}`: return ({
      ...state, penjualan: { ...state.penjualan, isSubmit: true }
    })
    case `${UPDATE_LISTING_EXPIRY}${PROMISE_FULFILLED}`: return _ChangePriceAndStatus(state, actions)
    case `${UPDATE_LISTING_EXPIRY}${PROMISE_REJECTED}`: return ({
      ...state, "penjualan": { ...state.penjualan, isSubmit: false, error: { ...actions.payload.response.data.error }, ...actions.payload.response.data.error }
    })

    case `${UPDATE_BULK_RENEW}${PROMISE_PENDING}`: return ({
      ...state, bulkExpiry: { ...state.bulkExpiry, isSubmit: true }
    })
    // case `${UPDATE_BULK_RENEW}${PROMISE_FULFILLED}`:return _ChangePriceAndStatus(state, actions.payload)
    case `${UPDATE_BULK_RENEW}${PROMISE_FULFILLED}`: {
      const { data, status_code, message } = actions.payload;
      return { ...state, bulkExpiry: { ...state.bulkExpiry, data, message, status_code, isSubmit: false, error: null } }
    }

    // case `${UPDATE_BULK_RENEW}${PROMISE_REJECTED}`: return({
    //     ...state, "bulkExpiry": {...state.bulkExpiry, isSubmit: false, error: {...actions.payload.response.data.error}, ...actions.payload.response.data.error}
    //   })
    case `${UPDATE_BULK_RENEW}${PROMISE_REJECTED}`:
      return { ...state, bulkExpiry: { ...state.bulkExpiry, error: actions.payload.response ? { ...actions.payload.response.data.error } : { message: actions.payload.message }, isSubmit: false } }

    case `${HOLIDAY_MODE_REQUEST}${PROMISE_PENDING}`:
      return { ...state, holidayMode: { ...state.holidayMode, isSubmit: true } }
    case `${HOLIDAY_MODE_REQUEST}${PROMISE_FULFILLED}`: {
      const { data, status_code, message } = actions.payload;
      return { ...state, holidayMode: { ...state.holidayMode, data, message, status_code, isSubmit: false, error: null } }
    }
    case `${HOLIDAY_MODE_REQUEST}${PROMISE_REJECTED}`:
      return { ...state, holidayMode: { ...state.holidayMode, error: actions.payload.response ? { ...actions.payload.response.data.error } : { message: actions.payload.message }, isSubmit: false } }

    case `${SELLER_INPUT_AWB}${PROMISE_PENDING}`:
      return { ...state, awb: { ...state.awb, isSubmit: true } }
    case `${SELLER_INPUT_AWB}${PROMISE_FULFILLED}`: {
      const { data, status_code, message } = actions.payload;
      return { ...state, awb: { ...state.awb, data, message, status_code, isSubmit: false, error: null } }
    }
    case `${SELLER_INPUT_AWB}${PROMISE_REJECTED}`:
      return { ...state, awb: { ...state.awb, error: { ...actions.payload.response.data.error }, isSubmit: false } }

    case `${SUSPEND_SELL_REQUEST}${PROMISE_FULFILLED}`: return _ChangePriceAndStatus(state, actions)
    case `${AUTH_SIGN_OUT}`:
      return ({ ...initialState })

    case `${FETCH_SHIPPING_TRACKING}${PROMISE_PENDING}`:
      return { ...state, shippingTrackingData: { ...state.shippingTrackingData, isFetch: true } }
    case `${FETCH_SHIPPING_TRACKING}${PROMISE_FULFILLED}`:
      const { data, status_code, message } = actions.payload;
      return { ...state, shippingTrackingData: { ...state.shippingTrackingData, data, message, status_code, isFetch: false, error: null } }
    case `${FETCH_SHIPPING_TRACKING}${PROMISE_REJECTED}`:
      return { ...state, shippingTrackingData: { ...state.shippingTrackingData, isFetch: false, error: onError(actions.payload) && onError(actions.payload).error } }
    default:
      return state
  }
}

export default historyReducer